import { AxiosError } from 'axios'

import { AppDispatch } from '../../store'
import ActivityDataStore from '../DataStore/ActivityDataStore'
import { transformActivity } from '../DataStore/transformer/ActivityTransformer'
import {
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_LOADING,
  GET_ACTIVITY_FAILURE,
  GET_ACTIVITY_CATEGORIES_LOADING,
  GET_DEPARTMENTS_FAILURE,
  GET_DEPARTMENTS_LOADING,
  GET_ACTIVITY_CATEGORIES_SUCCESS,
  GET_DEPARTMENTS_SUCCESS,
  GET_ACTIVITY_CATEGORIES_FAILURE,
  GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING,
  GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS,
  GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE,
} from '../interface/actionTypes'
import { IActivity } from '../interface/IActivity'
import { IActivityCategories } from '../interface/IActivityCategories'
import { IDepartment } from '../interface/IActivityState'
import { IActivityWithTreatmentCode } from '../interface/IActivityWithTreatmentCode'
import { transformAPIActivityWTC } from '../utils/transformAPIActivityWTC'

const getActivitySuccess = (list: IActivity[]) => {
  return {
    type: GET_ACTIVITY_SUCCESS,
    payload: {
      activity: list,
    },
  }
}

const getActivityFailure = (error: string) => {
  return {
    type: GET_ACTIVITY_FAILURE,
    payload: { error },
  }
}

export const getActivities = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_ACTIVITY_LOADING })
    ActivityDataStore.getAllActivities()
      .then(apiActivities => {
        const list = apiActivities.map(transformActivity)
        dispatch(getActivitySuccess(list))
      })
      .catch((error: AxiosError) => {
        dispatch(getActivityFailure(error.message))
      })
  }
}

const getActivitiesWithTreatmentCodeSuccess = (
  list: IActivityWithTreatmentCode[],
) => {
  return {
    type: GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS,
    payload: {
      activityWithCode: list,
    },
  }
}

const getActivitiesWithTreatmentCodeFailure = (error: string) => {
  return {
    type: GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE,
    payload: { error },
  }
}

export const getActivitiesWithTreatmentCode = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING })

    return ActivityDataStore.getActivitiesWithTreatmentCode()
      .then(apiActivitiesWithTreatmentCode => {
        const list: IActivityWithTreatmentCode[] =
          apiActivitiesWithTreatmentCode.data.list.map(transformAPIActivityWTC)
        dispatch(getActivitiesWithTreatmentCodeSuccess(list))
      })
      .catch((error: AxiosError) => {
        dispatch(getActivitiesWithTreatmentCodeFailure(error.message))
      })
  }
}

const getActivityCategoriesSuccess = (list: IActivityCategories[]) => {
  return {
    type: GET_ACTIVITY_CATEGORIES_SUCCESS,
    payload: { activityCategories: list },
  }
}

const getActivityCategoriesFailure = (error: string) => {
  return {
    type: GET_ACTIVITY_CATEGORIES_FAILURE,
    payload: { error },
  }
}

export const getActivityCategories = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_ACTIVITY_CATEGORIES_LOADING })

    return ActivityDataStore.getActivityCategories()
      .then(response => {
        const list = response.data.data.map(
          (dataRow: any) => dataRow.attributes,
        )

        dispatch(getActivityCategoriesSuccess(list))
      })
      .catch((error: AxiosError) => {
        dispatch(getActivityCategoriesFailure(error.message))
      })
  }
}

const getDepartmentsSuccess = (list: IDepartment[]) => {
  return {
    type: GET_DEPARTMENTS_SUCCESS,
    payload: { departments: list },
  }
}

const getDepartmentsFailure = (error: string) => {
  return {
    type: GET_DEPARTMENTS_FAILURE,
    payload: { error },
  }
}

export const getDepartments = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_DEPARTMENTS_LOADING })

    return ActivityDataStore.getDepartments()
      .then(response => {
        const list = response.data.list
        dispatch(getDepartmentsSuccess(list))
      })
      .catch((error: AxiosError) => {
        dispatch(getDepartmentsFailure(error.message))
      })
  }
}
